import { Breadcrumb } from "@/components/ui";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/content/rules")({
  component: () => (
    <Breadcrumb label="Rules" to="/content/rules">
      <Outlet />
    </Breadcrumb>
  ),
});
